<template>
    <div class="animated fadeIn CheckinDDAT">
    <div class="card">
        <div class="card-header">
            <span>{{aLang.sq_title}}</span>
        </div>
        <div class="card-body">
            <el-form
              @submit.native.prevent
              :model="mData.tableRules.dataSearch.value"
              :rules="mData.tableRules.dataSearch.valid"
              ref="myForm"
              label-width="100%"
              label-position="top"
            >
                <b-row>
                    <b-col md="6">
                        <el-form-item label="Số điện thoại" prop="sdt">
                            <el-input v-model="mData.tableRules.dataSearch.value.sdt" clearable></el-input>
                        </el-form-item>
                    </b-col>
                    <b-col md="6">
                        <el-form-item :label="aLang.sd_status">
                            <el-select v-model="mData.tableRules.dataSearch.value.type" :placeholder="aLang.c_select" :default-first-option="true">
                                <el-option
                                    v-for="item in mData.smsType"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                </b-row>
                <el-form-item class="text-center mt-3">
                    <el-button
                      type="info"
                      native-type="submit"
                      plain
                      v-ladda
                      @click="fn_tableSearch()"
                      >{{ aLang.c_search }}</el-button
                    >
                    <!-- <el-button
                      type="info"
                      plain
                      @click="fn_tableSearch()"
                      >{{ aLang.c_search }}</el-button
                    > -->
                </el-form-item>
            </el-form>
            <el-table
              class="table-custom"
              :data="mData.tableRules.data"
              border
              max-height="550"
              style="width: 100%"
            >
                <el-table-column
                    prop="time"
                    :label="aLang.sq_time"
                    width="150"
                    :formatter="fn_formatterDatetime"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="content"
                    :label="aLang.sq_content"
                    min-width="250"
                ></el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                <div class="col-md-4">
                </div>
                <div class="col-md-8 text-right pagination-wrap">
                    <el-pagination
                    @size-change="fn_tableSizeChange"
                    @current-change="fn_tableCurentChange"
                    @prev-click="fn_tablePrevClick"
                    @next-click="fn_tableNextClick"
                    :page-sizes="mData.tableRules.lengthMenu"
                    :page-size="mData.tableRules.limit"
                    :current-page="mData.tableRules.page"
                    background
                    layout="total, sizes, prev, pager, next"
                    :total="mData.tableRules.total"
                    :pager-count="5"
                    ></el-pagination>
                </div>
            </b-row>
        </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import TruyVanSMSModel from '@/views/admin/TruyVanSMS/TruyVanSMSModel';
import DiemDenAnToanApi from '@/moduleApi/DiemDenAnToanApi';
export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "TruyVanSMS", //requied
        dataForm: MethodService.copyObject(TruyVanSMSModel.dataForm),
        tableRules: MethodService.copyObject(TruyVanSMSModel.tableRules),
        smsType: DataService.smsType,
      },
      data: MethodService.copyObject(TruyVanSMSModel.dataSearch)
    };
  },
  computed: {},
  methods: {
    fn_tableSearch() {
        this.$refs["myForm"].validate(async (valid) => {
            if (valid) {
                this.data.sdt = this.mData.tableRules.dataSearch.value.sdt;
                this.data.type = this.mData.tableRules.dataSearch.value.type;
                this.data.limit = this.mData.tableRules.limit;
                this.data.skip = this.mData.tableRules.skip;
                console.log("this.data.skip",this.data.skip);
                this.fn_getData();
            } else {
                MethodService.stopLadda();
                return false;
            }
        });
    },
    async fn_getData(){
        const smsLog = await DiemDenAnToanApi.searchSMS(this.data);
        this.mData.tableRules.data = smsLog.result;
        this.mData.tableRules.total = smsLog.meta.total;
        this.mData.tableRules.page = smsLog.meta.skip / smsLog.meta.limit + 1;
        if (
        this.mData.tableRules.skip == smsLog.meta.total &&
        this.mData.tableRules.skip != 0
      ) {
        this.mData.tableRules.skip = 0;
        this.mData.tableRules.page = 1;
        this.fn_getData();
      }
    },
    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_tableSearch();
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.skip = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_tableSearch();
    },
  },

  //run after render view
  created() {
      this.mData.tableRules.dataSearch.value.type = "all";
  },
  mounted() {},
};
</script>
<style>
.table-custom .el-table__body-wrapper .el-table__row  .cell{
  word-break: normal;
  white-space: normal;
}
</style>